import React from "react";

export default function Eye(props: any) {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.746127 6.43258C0.581761 6.16415 0.581761 5.83585 0.746127 5.56742C1.37973 4.53266 3.21499 2 6 2C8.78501 2 10.6203 4.53266 11.2539 5.56742C11.4182 5.83585 11.4182 6.16415 11.2539 6.43258C10.6203 7.46734 8.78501 10 6 10C3.21499 10 1.37973 7.46734 0.746127 6.43258Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6 7.5C6.82843 7.5 7.5 6.82843 7.5 6C7.5 5.17157 6.82843 4.5 6 4.5C5.17157 4.5 4.5 5.17157 4.5 6C4.5 6.82843 5.17157 7.5 6 7.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
